let lastTrackedUrl
up.compiler('[track_for_analytics]', function(element, data, meta) {
  if (meta.revalidating) return

  if (typeof _paq !== 'undefined') {
    const trackingUrl = element.getAttribute('track_for_analytics') || up.history.location
    if (trackingUrl !== lastTrackedUrl) {
      // deal with relative and absolute urls
      const anchor = document.createElement('a')
      anchor.href = trackingUrl
      _paq.push(['setCustomUrl', anchor.href])
      _paq.push(['trackPageView'])
      lastTrackedUrl = trackingUrl
    }
  }
})
